import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import { GlueConfigurationService } from './glue-configuration.service';
import { ICategoryTreeNode } from '../models/catalog.models';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);
  private readonly categoryTreeUri: string = '/category-trees';
  glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private static handleError(error: any): Promise<any> {
    console.error('An error occurred in getNavigationBar()', error);
    return Promise.reject(error.message || error);
  }

  getCategoryTree(): Observable<ICategoryTreeNode[]>{
    const url: string = this.glueUrl + this.categoryTreeUri;
    return this.httpClient.get<ICategoryTreeNode[]>(url).pipe(
        catchError(CategoriesService.handleError)
    );
  }
}
